<mat-form-field class="w-100">
  <mat-label>Date d'expiration</mat-label>
  <input
    matInput
    placeholder="Cliquez sur l'icône pour changer la date"
    [min]="minDate"
    [matDatepicker]="picker"
    [formControl]="dateControl"
    (dateChange)="submit()"
    readonly />
  <mat-hint>JJ/MM/AAAA</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="picker" />
  <mat-datepicker #picker />
  @if (dateControl.hasError('matDatepickerParse')) {
  <mat-error>Format invalide</mat-error>
  } @if (dateControl.hasError('matDatepickerMin')) {
  <mat-error>Date dépassée</mat-error>
  }
</mat-form-field>
